// Type d'élément ajouté dans l'éditeur de questionnaire (paramètre `type` de questionnaireAdd)
export const questionnaireQuestionTypeConstante = Object.freeze({
  QUESTION: 1,
  TITLE: 2,
  QUESTION_CLUSTER: 3,
});
